import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
    { label: "Treatment", to: "/#what-is-aqualyx" },
    { label: "Results", to: "/results" },
    { label: "Clinics", to: "/clinics" },
    { label: "Journal", to: "/blog" },
    { label: "About", to: "/about" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => { setOpen(false); }, [location.pathname]);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-bone/80 backdrop-blur-xl border-b border-champagne/30"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2">
                    <span className="font-serif text-3xl tracking-tight">Aqualyx</span>
                    <span className="eyebrow text-[0.55rem] hidden sm:block">New Zealand</span>
                </Link>

                <nav className="hidden lg:flex items-center gap-10">
                    {NAV.map((item) => (
                        <a
                            key={item.to}
                            href={item.to}
                            data-testid={`nav-${item.label.toLowerCase()}`}
                            className="text-xs uppercase tracking-[0.22em] font-medium text-ink hover:text-champagne transition-colors duration-300"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <Link to="/clinics" data-testid="nav-find-clinic" className="btn-outline text-[0.65rem]">
                        Find Clinic
                    </Link>
                    <Link to="/contact" data-testid="nav-book" className="btn-primary text-[0.65rem]">
                        Book Consultation
                    </Link>
                </div>

                <button
                    onClick={() => setOpen(!open)}
                    data-testid="nav-mobile-toggle"
                    className="lg:hidden p-2"
                    aria-label="Toggle menu"
                >
                    {open ? <X strokeWidth={1.2} /> : <Menu strokeWidth={1.2} />}
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="lg:hidden bg-bone border-t border-champagne/30 px-6 py-8 space-y-6 animate-fade-in">
                    {NAV.map((item) => (
                        <a
                            key={item.to}
                            href={item.to}
                            className="block font-serif text-3xl"
                            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                        >
                            {item.label}
                        </a>
                    ))}
                    <div className="pt-4 flex flex-col gap-3">
                        <Link to="/clinics" className="btn-outline">Find Clinic</Link>
                        <Link to="/contact" className="btn-primary">Book Consultation</Link>
                    </div>
                </div>
            )}
        </header>
    );
}
